import React, { useState, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import "./PartnerBillDetails.css";
import cancel from "../../../../assests/cancel.svg";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import leftArrow from "../../../../assests/leftArrow.svg";
import billsummery from "../../../../assests/billsummery.svg";
import chargeicon from "../../../../assests/chargeicon.svg";

const PartnerBillDetailsComponent = ({
  loading,
  billData,
  payoutBillData,
  onGoBack,
  handleMiscCharge,
  handlePostBill,
  fetchChargeBillSummery,
  chargeSummery,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [showAllCharges, setShowAllCharges] = useState(false);
  const [showDeductionDetails, setShowDeductionDetails] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [calculatedEndDate, setCalculatedEndDate] = useState("");
  const [calculatedStartDate, setCalculatedStartDate] = useState("");

  useEffect(() => {
    if (billData || payoutBillData) {
      const startDate = calculateStartDate();
      const endDate = calculateEndDate(startDate);
      setCalculatedStartDate(startDate);
      setCalculatedEndDate(endDate);
    }
  }, [billData, payoutBillData]);

  // Helper function to get last date of month from a date string
  const getLastDateOfMonth = (dateString) => {
    try {
      // Check if dateString is valid
      if (!dateString || dateString === "N/A" || dateString === "null" || dateString === "undefined") {
        return "N/A";
      }
      
      // Try multiple date formats
      let date;
      if (dateString.includes("/")) {
        // DD/MM/YYYY format
        const [day, month, year] = dateString.split("/").map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateString.includes("-")) {
        // YYYY-MM-DD format
        date = new Date(dateString);
      } else {
        return "N/A";
      }
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return "N/A";
      }
      
      const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const formattedDay = String(lastDate.getDate()).padStart(2, "0");
      const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
      const formattedYear = lastDate.getFullYear();
      
      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    } catch (error) {
      console.error("Error calculating last date of month:", error);
      return "N/A";
    }
  };

  // Format date to DD/MM/YYYY
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString || dateString === "null" || dateString === "undefined" || dateString === "N/A") {
      return "N/A";
    }
    
    try {
      let date;
      if (dateString.includes("-")) {
        // YYYY-MM-DD format
        date = new Date(dateString);
      } else if (dateString.includes("/")) {
        // Already in DD/MM/YYYY format
        return dateString;
      } else {
        return dateString;
      }
      
      if (isNaN(date.getTime())) {
        return "N/A";
      }
      
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };

  const calculateStartDate = () => {
    // Use billData.startDate if available and valid
    if (billData?.startDate && billData.startDate !== "null" && billData.startDate !== "undefined" && billData.startDate !== "N/A") {
      return formatDateToDDMMYYYY(billData.startDate);
    }
    
    return "N/A";
  };

  const calculateEndDate = (startDate) => {
    // First check if billData.endDate exists and is valid
    if (billData?.endDate && billData.endDate !== "null" && billData.endDate !== "undefined" && billData.endDate !== "N/A") {
      return formatDateToDDMMYYYY(billData.endDate);
    }
    
    // If endDate is null/undefined, calculate month end from startDate
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") {
        return monthEndDate;
      }
    }
    
    return "N/A";
  };

  // Get formatted start date for display
  const getDisplayStartDate = () => {
    if (billData?.startDate) {
      return formatDateToDDMMYYYY(billData.startDate);
    }
    return "N/A";
  };

  // Get formatted end date for display (with month end calculation if null/undefined)
  const getDisplayEndDate = () => {
    if (billData?.endDate && billData.endDate !== "null" && billData.endDate !== "undefined") {
      return formatDateToDDMMYYYY(billData.endDate);
    }
    
    // If endDate is null/undefined, calculate from startDate
    const startDate = getDisplayStartDate();
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") {
        return monthEndDate;
      }
    }
    
    return "N/A";
  };

  // Separate function for charge summary end date calculation
  const getChargeSummaryEndDate = () => {
    // For charge summary, use the date from chargeSummery object
    if (chargeSummery?.date) {
      const chargeDate = new Date(chargeSummery.date);
      if (!isNaN(chargeDate.getTime())) {
        const lastDate = new Date(chargeDate.getFullYear(), chargeDate.getMonth() + 1, 0);
        const formattedDay = String(lastDate.getDate()).padStart(2, "0");
        const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
        const formattedYear = lastDate.getFullYear();
        return `${formattedDay}/${formattedMonth}/${formattedYear}`;
      }
    }
    
    // Fallback to regular calculation
    return calculatedEndDate;
  };

  if (loading) return <LoadingSpinner />;
  if (!billData) return <div>No bill data available.</div>
  console.log("payoutdata", payoutBillData);

  const handleViewClick = (charge) => {
    setSelectedCharge(charge);
    setOpenDialog(true);
  };

  const totalTransactionalAmount = chargeSummery?.transactionalCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0
  );

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    })
      .format(amount)
      .replace("₹", "₹ ");
  };

  // Fixed total calculate
  const totalFixedAmount = chargeSummery?.fixedCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0
  );

  const handleDeductionClick = (payoutId, totalDeductions) => {
    if (totalDeductions > 0) {
      fetchChargeBillSummery(payoutId); // Pass the specific payoutId
      setShowDeductionDetails(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, Math.max(0, billData?.charges?.length - 4))
    );
  };

  const visibleCharges =
    billData?.charges?.slice(currentIndex, currentIndex + 4) || [];
  const showArrows = billData?.charges?.length > 4;

  // Format date for charge summary display
  const formatChargeSummaryDate = () => {
    if (chargeSummery?.date) {
      const date = new Date(chargeSummery.date);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      }
    }
    return "N/A";
  };

  return (
    <div className="partner-bill-layout">
      <Sidebar />
      <div className="partner-bill-summary">
        <div style={{ display: "flex", alignItems: "center" }}>
          <button className="back-buttonpayoutDetails" onClick={onGoBack}>
            <img src={leftArrow} alt="" />
          </button>

          <h2 className="partner-title">
            Partner- {billData.name} (Owner ID:{billData.franchiseeId})
          </h2>
        </div>

        <div className="bill-id-banner">
          <div className="bill-id-left">
            Bill ID - <span style={{ fontWeight: 400 }}> {billData.billId}</span>
          </div>
          <div className="bill-id-left">
            {" "}
            Total VM: <span style={{ fontWeight: 400 }}>{payoutBillData.vmCount}</span>
          </div>
          <div className="bill-id-right">
            <img src={billsummery} alt="" /> Start Date:
            <span style={{ fontWeight: 400 }}>{getDisplayStartDate()} </span> &nbsp; End
            Date:<span style={{ fontWeight: 400 }}>{getDisplayEndDate()}</span>
          </div>
        </div>

        <div className="bill-charges-section">
          <div className="charges-header">
            <h4>Charges Applied on this Bill</h4>
            {billData.status !== "CLOSED" && (
              <Button
                variant="outlined"
                className="add-charge-btn"
                onClick={handleMiscCharge}
              >
                Add Misc. Charge
              </Button>
            )}
          </div>

          <div className="charges-carousel">
            {showArrows && (
              <IconButton
                className="carousel-arrow left-arrow"
                onClick={handlePrev}
                disabled={currentIndex === 0}
              >
                <ChevronLeftIcon />
              </IconButton>
            )}

            <div className="charges-container">
              {visibleCharges.map((charge, i) => (
                <div className="charge-banner" key={i}>
                  {charge.chargeType === "misc_charge" && (
                    <div className="misc-badge">M</div>
                  )}

                  <div className="charge-details">
                    <div className="charge-row">
                      <span className="charge-label">Name:</span>
                      <span className="charge-value">{charge.chargeType}</span>
                    </div>
                    <div className="charge-row">
                      <span className="charge-label">Value:</span>
                      <span className="charge-value">{charge.amount}</span>
                    </div>
                  </div>

                  <IconButton
                    className="chargeview-icon"
                    onClick={() => handleViewClick(charge)}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </div>
              ))}
            </div>

            {showArrows && (
              <IconButton
                className="carousel-arrow right-arrow"
                onClick={handleNext}
                disabled={currentIndex >= billData?.charges?.length - 4}
              >
                <ChevronRightIcon />
              </IconButton>
            )}
          </div>
        </div>

        <Dialog
          open={openDialog}
          className="charge-dialog"
          PaperProps={{
            style: {
              borderRadius: "12px",
              padding: "20px",
              minWidth: "400px",
            },
          }}
        >
          <DialogTitle
            className="dialog-title"
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img src={chargeicon} alt="" />
            <div>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", textAlign: "left" }}
              >
                {selectedCharge?.name}
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ textAlign: "center", color: "#666" }}
              >
                Applied on {selectedCharge?.date || getDisplayStartDate()}
              </Typography>
            </div>
          </DialogTitle>
          <DialogContent className="dialog-content" style={{ textAlign: "left" }}>
            <div className="charge-detail-item">
              <span className="detail-label">ID:</span>
              <span className="detail-value">{selectedCharge?.id || "117"}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Name:</span>
              <span className="detail-value">{selectedCharge?.name}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Descriptions:</span>
              <span className="detail-value">{selectedCharge?.description}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Beneficiary Type ID:</span>
              <span className="detail-value">
                {selectedCharge?.beneficiaryTypeId || "N/A"}
              </span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Charge Type:</span>
              <span className="detail-value">{selectedCharge?.chargeType}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Value Type:</span>
              <span className="detail-value">
                {selectedCharge?.valueType || "N/A"}
              </span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Value Amount:</span>
              <span className="detail-value">{selectedCharge?.amount}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Value Min:</span>
              <span className="detail-value">{selectedCharge?.valueMin}</span>
            </div>
            <div className="charge-detail-item">
              <span className="detail-label">Value Max:</span>
              <span className="detail-value">{selectedCharge?.valueMax}</span>
            </div>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center", padding: "20px" }}>
            <Button
              onClick={handleCloseDialog}
              variant="contained"
              style={{
                backgroundColor: "#14AE78",
                color: "white",
                borderRadius: "8px",
                padding: "8px 24px",
                textTransform: "none",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showDeductionDetails}
          maxWidth="md"
          fullWidth
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <DialogTitle>
              {formatChargeSummaryDate()}
              {chargeSummery?.payoutId ? ` (Payout ID ${chargeSummery.payoutId})` : ""}
            </DialogTitle>
            <img
              onClick={() => setShowDeductionDetails(false)}
              src={cancel}
              alt=""
              style={{
                textTransform: "none",
                borderRadius: "4px",
                padding: "6px 16px",
                fontSize: "14px",
                alignItems: "center",
              }}
            />
          </div>

          <DialogContent style={{ padding: "0 24px 24px" }}>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <div
                  style={{
                    border: "2px dashed yellow",
                    padding: "10px 24px 24px",
                  }}
                >
                  <div style={{ marginBottom: "20px", fontSize: "14px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>
                        <strong>Partner Name</strong> –{" "}
                        {chargeSummery?.name || "N/A"} ({chargeSummery?.type})
                        <br />
                        <strong>Cohort ID</strong> –{" "}
                        {chargeSummery?.cohortId || "N/A"}
                      </div>
                      <div>
                        <strong>Partner Id</strong> –{" "}
                        {chargeSummery?.franchiseeId || "N/A"}
                        <br />
                        <strong>Total VM</strong> – {chargeSummery?.vmCount || "N/A"}
                      </div>
                    </div>
                  </div>

                  <h4 style={{ margin: "16px 0 8px", fontSize: "14px" }}>
                    Charge Summary (Transactional)
                  </h4>
                  <TableContainer
                    component={Paper}
                    style={{
                      marginBottom: "20px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Table size="small" style={{ border: "none" }}>
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Deduction ID
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chargeSummery?.transactionalCharges?.map((charge) => (
                          <TableRow
                            key={`transactional-${charge.id}`}
                            style={{ border: "none" }}
                          >
                            <TableCell style={{ border: "none" }}>{charge.id}</TableCell>
                            <TableCell style={{ border: "none" }}>
                              {charge.chargeType === "raas_fee"
                                ? "RAAS Fee(%)"
                                : charge.chargeType === "ps_fee"
                                ? "PS Fee(%)"
                                : charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: "none" }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          style={{
                            fontWeight: "bold",
                            border: "none",
                            border: "1px solid #ccc",
                          }}
                        >
                          <TableCell colSpan={2} style={{ border: "none" }}>
                            % Charge Total
                          </TableCell>
                          <TableCell align="right" style={{ border: "none" }}>
                            {formatCurrency(totalTransactionalAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <h4 style={{ margin: "16px 0 8px", fontSize: "14px" }}>
                    Charge Summary (Fixed)
                  </h4>
                  <TableContainer
                    component={Paper}
                    style={{
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <Table size="small" style={{ border: "none" }}>
                      <TableHead>
                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Deduction ID
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", border: "none", textAlign: "center" }}
                          >
                            Amount
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chargeSummery?.fixedCharges?.map((charge) => (
                          <TableRow key={`fixed-${charge.id}`} style={{ border: "none" }}>
                            <TableCell style={{ border: "none" }}>{charge.id}</TableCell>
                            <TableCell style={{ border: "none" }}>
                              {charge.chargeType === "saas_ik"
                                ? "SAAS IK"
                                : charge.chargeType === "rental_ik"
                                ? "Rental IK"
                                : charge.chargeType === "misc_charge"
                                ? "Miscellaneous"
                                : charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: "none" }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          style={{
                            fontWeight: "bold",
                            border: "none",
                            border: "1px solid #ccc",
                          }}
                        >
                          <TableCell colSpan={2} style={{ border: "none" }}>
                            Fix Charge Total
                          </TableCell>
                          <TableCell align="right" style={{ border: "none" }}>
                            {formatCurrency(totalFixedAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <div
                    style={{
                      marginTop: "20px",
                      fontWeight: "bold",
                      fontSize: "14px",
                      textAlign: "left",
                      backgroundColor: "#D9D9D980",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                    }}
                  >
                    Total Deduction (Transactional + Fixed) ={" "}
                    {formatCurrency(
                      (totalTransactionalAmount || 0) +
                        (totalFixedAmount || 0)
                    )}
                  </div>
                </div>
              </>
            )}
          </DialogContent>
        </Dialog>

        <div className="summary-section">
          <div className="summary-header">
            <h4>
              📅 Bill Summary -{" "}
              <span style={{ fontSize: "14px" }}>{payoutBillData.startDate}</span>{" "}
              <span style={{ fontSize: "14px" }}>to</span>{" "}
              <span style={{ fontSize: "14px" }}>{payoutBillData.endDate}</span>
              <span
                className={`status-badgepayout ${billData.status?.toLowerCase()}`}
              >
                {" "}
                {billData.status}{" "}
              </span>
            </h4>
            <a className="past-bills-link" onClick={handlePostBill}>
              View Past Bills
            </a>
          </div>
          <div className="summary-cards">
            <div className="summary-card">
              <div>Total Gross Sale</div>
              <strong>{payoutBillData.totalGrossSale}</strong>
            </div>
            <div className="summary-card">
              <div>Total Fix Deduction</div>
              <strong>{payoutBillData.totalFixedDeductions}</strong>
            </div>
            <div className="summary-card">
              <div>Total Transactional Deduction</div>
              <strong>{payoutBillData.totalTransactionalDeductions}</strong>
            </div>
            <div className="summary-card">
              <div>Net Payout</div>
              <strong>{payoutBillData.totalNetPayable}</strong>
            </div>
          </div>
        </div>

        <div className="table-section">
          <h4>📊 Day Wise Payout Details</h4>
          <div className="table-wrapper-details">
            <table className="payout-table">
              <thead>
                <tr>
                  <th>Days</th>
                  <th>Settlement ID</th>
                  <th>Total Gross Sale</th>
                  <th>Net Payout</th>
                  <th>Total Deduction</th>
                </tr>
              </thead>
              <tbody>
                {payoutBillData &&
                  payoutBillData?.payouts?.map((day, i) => (
                    <tr key={i}>
                      <td>{day.date}</td>
                      <td>{day.payoutId}</td>
                      <td>{day.revenueToday}</td>
                      <td>{day.netPayable}</td>
                      <td>
                        <span
                          style={{
                            color: day.totalDeductions > 0 ? "blue" : "inherit",
                            textDecoration:
                              day.totalDeductions > 0 ? "underline" : "none",
                            cursor: day.totalDeductions > 0 ? "pointer" : "default",
                          }}
                          onClick={() =>
                            handleDeductionClick(day.payoutId, day.totalDeductions)
                          }
                        >
                          {day.totalDeductions}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerBillDetailsComponent;